import { Marker, useMapEvents } from 'react-leaflet';
import { useState, useEffect } from 'react';

function LocationSelector({ position, onChange }) {
  const [marker, setMarker] = useState(position);

  useEffect(() => {
    setMarker(position);
  }, [position]);

  useMapEvents({
    click(e) {
      setMarker(e.latlng);
      if (typeof onChange === 'function') {
        onChange(e.latlng);
      }
    },
  });

  return marker ? <Marker position={marker} /> : null;
}

export default LocationSelector;
